import { AutoRenewType } from './AutoRenewType';
import { IntervalType } from './IntervalType';

export interface DtoMemberType {
    id: number;
    name: string;
    description: string | null;
    forCompanies: boolean;
    requireImmediatePayment: boolean;
    autoRenewType: AutoRenewType;
    eligibleForSelection: boolean;
    seatBased: boolean;
    requireApplication: boolean;
    hasPromoCodes: boolean;
    paymentPlansEnabled: boolean;
    hasAutoPayRelatedDuesRules: boolean;
    treatAsNewRenewal: number;
    treatAsNewRenewalInterval: IntervalType;
}


export function createDtoMemberType(dtoMemberType?: DtoMemberType | any) {
    const result = <DtoMemberType>{
        id: 0,
        name: '',
        description: null,
        forCompanies: false,
        requireImmediatePayment: false,
        autoRenewType: AutoRenewType.Disabled,
        eligibleForSelection: true,
        requireApplication: false,
        hasPromoCodes: false,
        paymentPlansEnabled: false,
        hasAutoPayRelatedDuesRules: false,
        treatAsNewRenewal: 0,
        treatAsNewRenewalInterval: IntervalType.Years
    };

    if (dtoMemberType) {
        Object.assign(result, dtoMemberType);
    }
    return result;
}